/**
 * No-default-variant gate (part 3 of 3 — see sections/main-product.liquid).
 *
 * Loaded as a module, so it executes after theme.js has upgraded all custom elements:
 * ProductForm has already re-enabled the hidden id input, and ProductRerender's
 * product:rerender listener is registered before ours — meaning by the time our "lift"
 * handler runs, the server-rendered HTML (real price, enabled buttons, checked options)
 * has already been morphed into the page.
 */
for (const root of document.querySelectorAll('div[data-awaiting-selection]')) {
  const rerender = root.querySelector('product-rerender[observe-form]');
  if (!rerender) continue;

  const formId = rerender.getAttribute('observe-form');
  const form = document.getElementById(formId);
  if (!form || !form.elements.id) continue;

  // Nothing is selected: make sure nothing can be submitted or auto-added
  form.elements.id.value = '';

  // Capture-phase guard runs before ProductForm's own submit listener
  const guard = (event) => {
    if (event.target === form) {
      event.preventDefault();
      event.stopPropagation();
      root.querySelector('variant-picker')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };
  document.addEventListener('submit', guard, true);

  // First selection → theme fetched + morphed the real state → remove the gate
  form.addEventListener('product:rerender', function lift() {
    form.removeEventListener('product:rerender', lift);
    document.removeEventListener('submit', guard, true);
    root.removeAttribute('data-awaiting-selection');

    // The morph replaces buy-buttons and the sticky bar with enabled server HTML;
    // this only cleans up any button the morph did not touch.
    document.querySelectorAll('[data-gate-disabled]').forEach((button) => {
      button.disabled = false;
      button.removeAttribute('data-gate-disabled');
    });
  });
}
